"use strict";
(self["webpackChunklilacst"] = self["webpackChunklilacst"] || []).push([[5548],{

/***/ 5548:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ accordion)
/* harmony export */ });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4692);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);


/**
 * Accordion Group
 * ---------------
 * @param { HTMLElement } wrapper - [data-component="accordion"]
 * @summary
 *  Activates an accordion by URL hash relative links on page load
 *  Toggles active class on button and content
 *  Scrolls to active accordion when open
 *  Updates hash links on accordion button click
 */

// aria-controls="content-id"
// aria-expanded="true/false"

function accordion({ wrapper }) {
  const { classes } = window.config

  const selectors = {
    target: jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).data('target'),
    siblings: '[data-component="accordion"]',
    group: '[data-hook="accordion-group"]',
    updateHashAttr: 'data-update-hash',
  }

  const cache = {
    $wrapper: jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper),
    $target: jquery__WEBPACK_IMPORTED_MODULE_0___default()(selectors.target),
    $group: jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).parents(selectors.group),
  }

  const settings = {
    isToggleGroup: !!cache.$group.length,
    updateHashOnChange: true,
  }

  const lifecycle = {
    change: 'accordion:change',
    close: 'accordion:close',
  }

  ;(function init() {
    updateSettings()
    setDefaultAccessibleAttrs()

    cache.$wrapper.on('click', handleButtonClick)

    if (settings.updateHashOnChange) {
      cache.$wrapper.on(lifecycle.change, updateURLHash)
    }

    if (settings.isToggleGroup) {
      cache.$wrapper.on(lifecycle.change, triggerClose)
      cache.$wrapper.on(lifecycle.close, closeContent)
    }

    if (location.hash.length > 0) {
      toggleAccordionById(location.hash)
    }
  })()

  function updateSettings() {
    // Check if 'updateHashOnChange' was manually disabled
    if (wrapper.hasAttribute(selectors.updateHashAttr)) {
      settings.updateHashOnChange = jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).attr(selectors.updateHashAttr) != 'false'
    }
  }

  function setDefaultAccessibleAttrs() {
    const isActive = cache.$target.hasClass(classes.active)
    const targetId = cache.$target.attr('id')

    cache.$wrapper.attr('aria-expanded', isActive)
    cache.$wrapper.attr('aria-controls', targetId)
  }

  function handleButtonClick(event) {
    const isActive = cache.$target.hasClass(classes.active)

    cache.$wrapper.attr('aria-expanded', !isActive)

    cache.$wrapper.toggleClass(classes.active, !isActive)
    cache.$target.toggleClass(classes.active, !isActive)

    cache.$wrapper.trigger(lifecycle.change)
  }

  function updateURLHash() {
    const newHash = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).attr('id')

    history.replaceState({}, '', '#' + newHash)
  }

  function triggerClose(event) {
    cache.$group.find(selectors.siblings).not(cache.$wrapper).trigger(lifecycle.close)
  }

  function closeContent(event) {
    cache.$wrapper.removeClass(classes.active)
    cache.$target.removeClass(classes.active)
  }

  function toggleAccordionById(id) {
    if (cache.$wrapper.is(id) && !cache.$wrapper.hasClass(classes.active)) {
      cache.$wrapper.trigger('click')

      // allow for transition time
      setTimeout(function () {
        cache.$wrapper[0].scrollIntoView()
      }, 300)
    }
  }
}


/***/ })

}]);